export const SUCCESS = 'cashInPrices/SUCCESS';
export const FAILURE = 'cashInPrices/FAILURE';
export const INITIALIZE_CASH_PRICE = 'cashInPrices/INITIALIZE_PRICE';

export const success = (results) => ({
  type: SUCCESS,
  results
});

export const failure = (error) => ({
  type: FAILURE,
  error
});

export const initializeBetCashInPrice = id => ({
  type: INITIALIZE_CASH_PRICE,
  id
});
